// extracted by mini-css-extract-plugin
module.exports = {"image":"BQZ0tBItNZjbgVAHrvHi9g=="};